* {
  box-sizing: border-box;
}

:host {
  display: none;
  max-width: 100%;
  height: 100%;
  background-color: var(--white-layout-302-level-1-elevation);
  flex-direction: column;
  overflow-y: hidden;
}

:host([data-is-visible]) {
  display: block;
}

.header,
.content,
.footer {
  width: 100%;
}

.footer {
  display: flex;
  align-self: flex-end;
  box-shadow: 0px 0px 4px var(--chart-104-pressed);
  background-color: var(--white-layout-301-level-0-elevation);
  padding: calc(1.75 * var(--spacer)) calc(5 * var(--spacer));
  z-index: 10;

  &--button {
    margin-right: calc(2 * var(--spacer));

    &#btnCancel {
      margin-left: auto;
      margin-right: 0;
    }
  }
}

.wrapper {
  flex-direction: column;

  .content {
    min-width: 500px;
    height: 100%;
    overflow-y: scroll;
    padding: 0 calc(4 * var(--spacer)) 50px;
  }
}

.form-section {
  max-width: 700px;
  width: 100%;
  height: auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  .flex-group {
    display: flex;
    align-items: flex-start;
    color: var(--main-titles-inputs-600);
  }

  .categories-container {
    display: flex;
    align-items: center;

    gz-form-field {
      display: flex;
    }
  }
}

gz-button .ds-icon-add {
  line-height: 25px;
  margin-left: -5px;
  margin-right: 5px;
  font-size: 25px;
}
